import React from "react";
import { Spinner } from "react-bootstrap";

/**
 * Scoped loader for a single section/card/table — does not block the rest of the UI.
 */
function SectionLoader({ label = "Loading...", size = "md", className = "", style }) {
  const spinnerSize = size === "sm" ? "sm" : undefined;
  return (
    <div
      className={`revize-section-loader ${className}`.trim()}
      role="status"
      aria-live="polite"
      aria-busy="true"
      style={style}
    >
      <Spinner
        animation="border"
        variant="primary"
        size={spinnerSize}
        className={size === "sm" ? "revize-section-spinner-sm" : "revize-section-spinner"}
      />
      {label ? <span className="revize-section-loader-label">{label}</span> : null}
      <span className="visually-hidden">{label || "Loading"}</span>
    </div>
  );
}

export default SectionLoader;
